import { checkInGame, gameLink } from '@/api/game';
import { accountLogin } from '@/api/user';
import { LandScapeGameId, LOCAL_STORE, WEB_PACKAGE_NAME_HANDLE } from '@/config/constConfig';
import { i18n } from '@/i18n/config';
import store from '@/store';
import { FbEvent } from '@/utils/FbEvent';
import { AdJustAndroidEvent } from '@/utils/AdJustAndroidEvent';
import { getDeviceId, showAlert } from '@/utils/function';
import { KwaiqEvent } from '@/utils/KwaiqEvent';
import message from '@/utils/message';
import { nextTick } from 'vue';
import { changeScene } from './chcpHandle';

/**自动注册 */
export function autoRegistration() {
    let params: any = {
        loginType: "1",
        deviceId: getDeviceId(),
        extensionCode: store.state.code,
        apiType: 2,
        href: window.location.href,
        fbc: FbEvent.getFbc(),
        fbp: FbEvent.getFbp(),
        fbEventUrl: FbEvent.getEventUrl(),
        fbClientUserAgent: FbEvent.getUserAgent(),
        //fixedVersionType: "2"//专用于测试 玩家类型版本
    }
    
    if (store.state.version > 0) {
        params.fixedVersionType = store.state.version;
    }
    let adjustData = localStorage.getItem(LOCAL_STORE.ADJUST_DATA);
    if (adjustData) {
        params.registerInfo = adjustData;
    }
    let googleId = localStorage.getItem(LOCAL_STORE.GOOGLE_ID);
    if (googleId) {
        params.googleAdvId = googleId;
    }
    let packageName = localStorage.getItem(LOCAL_STORE.PACKAGE_NAME);
    if (packageName) {
        params.packageName = packageName;
    } else {
        // params.packageName = WEB_PACKAGE_NAME_HANDLE.H5_CLIENT;
    }
    accountLogin(params).then((res: any) => {
        if (res.data.success) {
            HandleloginSucess(res.data.data);
        } else {
            message({ text: res.msmg });
        }
    });

};

/**处理登录成功 */
function HandleloginSucess(res: any) {
    initLocal(res);
    initStore(res);
    if (res.isRegister) {
        store.state.isShowNewPlayer = true;
    }
    //上报首次注册事件
    let eventId = "userId_" + res.userId;
    //res.reportFbFlag ? FbEvent.EventRegistr(eventId) : "";
    AdJustAndroidEvent.registerAdjust();
    res.reportFbFlag && res.isRegister ? KwaiqEvent.EventRegistr() : "";
}

/**初始化本地存储信息 */
function initLocal(result: any) {
    let userMsg = {
        isLogin: 1,
        nickName: result.nick,
        userId: result.userId,
        token: result.token,
        userType: result.utype,
        vipLevel: 0,
    };
    localStorage.setItem(LOCAL_STORE.USER_INFO, JSON.stringify(userMsg));
}

/**初始化全局参数 */
function initStore(result: any) {
    store.state.isLogin = 1;
    store.state.accountInfo.gold = result.gold;
    store.state.userId = result.userId;
    store.state.nickName = result.nick;
    store.state.token = result.token;
    store.state.userType = result.utype; //获取哪一个客服链接
}

export function getGameLink(gameId: number, sceneId: number | null = null) {
    gameLink({ gameId: gameId, sessionId: sceneId }).then(res => {
        if (res.data.success == false) {
            return;
        } else {
            let url = res.data.data.jumpUrl;
            let params = new URLSearchParams(url);
            store.state.gameUrl = url;
            if (LandScapeGameId.indexOf(gameId) != -1) {
                if (process.env.VUE_APP_ISAPP == "true") {
                    store.state.isShowMaskBg = true;
                    changeScene("l");   //改变方向 横屏
                } else {
                    rotateScreen();
                }
                setTimeout(() => {
                    store.state.isShowMaskBg = false;
                }, 2000);
            }
        }
    });
}

/**检测用户是否处于游戏中 */
export function checkUserInGame() {
    checkInGame({}).then(res => {
        if (res.data.success == false) {
            return;
        }
        if (res.data.data.inGame) {
            showAlert(true, {
                title: 'common.1',
                msg: i18n.global.t('times.6'),
                btnType: 1,
                isShowClose: false,
                confirmCall: () => {
                    store.state.gameUrl = res.data.data.url;
                }
            });
        }
    })
}

export async function rotateScreen() {
//   const el = document.documentElement;
//   await el.requestFullscreen(); // 请求全屏
//   await screen.orientation.lock('landscape'); // 锁定横屏
    nextTick(() => {
        store.state.isHor = true;
    });
}